import { scim } from '@talend/context';

import { PATHS } from '../../constants';
import { SidePanelEntries, SidePanelLink, SubApp } from '../../types/sub-app-system';

export function getSidePanelEntries(subApplications: SubApp[]): SidePanelEntries {
	// Get all the entries
	const sidePanelEntries = subApplications
		.map(({ getSidePanelMenus }): SidePanelEntries => getSidePanelMenus())
		.filter(Boolean)
		.reduce((acc, menus: SidePanelEntries) => ({ ...acc, ...menus }), {});

	// Filter the entries by entitlements
	const meCache = scim.me.getCache();
	return Object.entries(sidePanelEntries)
		.filter(([, conf]) => scim.me.hasOneOfEntitlements(meCache, conf.entitlements || []))
		.reduce((acc, [key, conf]) => ({ ...acc, [key]: { ...conf } }), {});
}

export function getSidePanelEntriesByOrder(sidePanelEntries: SidePanelEntries): SidePanelLink[] {
	const { health, datasets, connections, rule, semantic, cad } = sidePanelEntries;
	// use the feature flag to display rule or not
	return [health, datasets, connections, rule, semantic, cad].filter(Boolean);
}

export function getLandingUrl(sidePanelEntries: SidePanelEntries): string {
	return getSidePanelEntriesByOrder(sidePanelEntries)[0]?.href || PATHS[403];
}
